import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { myLeaveHandleLeaveRequestsPageRoutePath } from "my-leave/configs/routes";
import { useMyLeaveAdminBadges } from "my-leave/hooks";
import { useOcIsMobile } from "oc/hooks";
import { ocNarrowMenuState } from "states";

export const useMyLeaveHeaderAdminBadge = (): {
  handleClick: () => void;
  count: number;
} => {
  const history = useHistory();
  const isMobile = useOcIsMobile();
  const [narrowMenuOpened, setNarrowMenuOpened] =
    useRecoilState(ocNarrowMenuState);

  const { data } = useMyLeaveAdminBadges();

  const handleClick = () => {
    if (isMobile) {
      setNarrowMenuOpened(!narrowMenuOpened);
    }
    history.push(myLeaveHandleLeaveRequestsPageRoutePath);
  };

  const count: number = data ?? 0;

  return {
    handleClick,
    count,
  };
};
